import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeviceInfoResponse } from 'src/app/shared/models/DeviceInfoResponse';
import { ConfigurationService } from '@ciam/library';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DeviceListService {

  constructor(
    private http: HttpClient,
    private config: ConfigurationService
  ) {}

  getTrustedDeviceInfo(): Observable<DeviceInfoResponse> {
    const deviceInfoUrl = this.config.select<string>('endpoints.deviceInfo.url');

    return this.http.get(deviceInfoUrl, { withCredentials: true }).pipe(timeout(Number(this.config.select<number>('endpoints.deviceInfo.timeout'))));
  }

 removeDevice(deviceId: string): Observable<DeviceInfoResponse> {
    let deviceInfoUrl = this.config.select<string>('endpoints.deviceInfo.url');
    deviceInfoUrl = `${deviceInfoUrl}?ids=${deviceId}`;
    return this.http.delete(deviceInfoUrl, { withCredentials: true }).pipe(
      timeout(Number(this.config.select<number>('endpoints.deviceInfo.timeout')))
    );
  }
}
